var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#21241E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 2v3M16.5 2v3M4 9.09h17M21.5 8.5V17c0 3-1.5 5-5 5h-8c-3.5 0-5-2-5-5V8.5c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5ZM12.492 13.7h.005M8.797 13.7h.005M8.797 16.7h.005"
}))));
export { SvgCalendar2 as ReactComponent };
export default __webpack_public_path__ + "f47e70317ed39712231729076d81bb82.svg";